import { getDomainUserId } from 'analytics/snowplow/helpers/domainUserId'
import { getCookies } from 'lib/web/cookieUtils'

export const TRIP_PLANNER_VISITOR_COOKIE = 'lux_trip_planner_visitor_id'

export function getTripPlannerVisitorId(): string | undefined {
  if (typeof document === 'undefined') {
    return undefined
  }

  const cookies = getCookies()
  return cookies[TRIP_PLANNER_VISITOR_COOKIE] ?? getDomainUserId()
}
